import { createFileRoute } from "@tanstack/react-router";
import * as React from "react";

import {
  ConsoleConnectorsPage,
  consoleConnectorsQueryOptions,
  consoleCustomConnectorsQueryOptions,
} from "@/features/console";
import {
  type ConsoleConnectorsSearch,
  validateConsoleConnectorsSearch,
} from "@/features/console/connectors/search";

export const Route = createFileRoute("/_authed/_modal/console/connectors/")({
  validateSearch: validateConsoleConnectorsSearch,
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleConnectorsQueryOptions());
    // Warm the "Personalizzati" tab so switching to it is instant.
    void queryClient.ensureQueryData(consoleCustomConnectorsQueryOptions());
  },
  component: ConnectorsRoute,
});

function ConnectorsRoute(): React.ReactElement {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onSearchChange = React.useCallback(
    (patch: Partial<ConsoleConnectorsSearch>) => {
      // ``undefined`` values drop the param — filters and the connect modal
      // stay fully deep-linkable without history spam.
      void navigate({
        replace: true,
        search: (prev) => ({ ...prev, ...patch }),
      });
    },
    [navigate],
  );
  return <ConsoleConnectorsPage search={search} onSearchChange={onSearchChange} />;
}
